/* eslint-disable react/react-in-jsx-scope */
import IconExcel from "@/assets/icones/excel.svg?react";
import IconImg from "@/assets/icones/images.svg?react";
import IconOds from "@/assets/icones/ods.svg?react";
import IconPdf from "@/assets/icones/pdf.svg?react";
import IconWord from "@/assets/icones/word.svg?react";
import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Download, Eye, MoreVertical } from "lucide-react";
import { useEffect, useState } from "react";

type OfficeThumbnailProps = {
  srcUrl: string;
  width?: string;
  height?: string;
  extension: string | undefined;
  treeFinancer: any;
  pj: any;
  noMore?: boolean;
};

export const OfficeThumbnail = ({
  srcUrl,
  width = "248px",
  height = "320px",
  extension,
  treeFinancer,
  pj,
  noMore = false,
}: OfficeThumbnailProps) => {
  const [open, setOpen] = useState(false);
  const [isThumbLoading, setIsThumbLoading] = useState(true);
  const encoded = encodeURIComponent(srcUrl);
  const iframeSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encoded}`;
  const icon: Record<string, JSX.Element> = {
    pdf: <IconPdf width={18} height={18} />,
    doc: <IconWord width={18} height={18} />,
    docx: <IconWord width={18} height={18} />,
    xlsx: <IconExcel width={18} height={18} />,
    ods: <IconOds width={18} height={18} />,
  };

  useEffect(() => {
    setIsThumbLoading(true);
  }, [srcUrl]);

  return (
    <div className={` ${!noMore && "bg-muted p-3"} rounded-md relative`}>
      {!noMore && (
        <div className="flex justify-between items-center relative z-10 mb-2">
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                className="flex items-center gap-3 "
                style={{ width: "calc(100% - 45px)" }}
              >
                {(extension && icon[extension]) || (
                  <IconImg width={18} height={18} />
                )}
                <h3 className="truncate flex-1">{pj.name}</h3>
              </div>
            </TooltipTrigger>
            <TooltipContent className="flex flex-col gap-2">
              <div>
                Porteur de projet :{" "}
                <strong>
                  {treeFinancer?.find((t) => t.id === pj.pp)?.name}
                </strong>
              </div>
              <div>
                Programme :{" "}
                <strong>
                  {
                    treeFinancer
                      ?.find((t) => t.id === pj.pp)
                      ?.programs.find((p) => p.id === pj.program)?.name
                  }
                </strong>
              </div>
              <div>
                Projet :{" "}
                <strong>
                  {
                    treeFinancer
                      ?.find((t) => t.id === pj.pp)
                      ?.programs.find((p) => p.id === pj.program)
                      ?.projects.find((p) => p.id === pj.project)?.name
                  }
                </strong>
              </div>
            </TooltipContent>
          </Tooltip>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                className="px-2 outline-none border-0 border-none ring-0 hover:bg-black/5 w-auto h-auto"
              >
                <MoreVertical className="text-foreground" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="flex flex-col gap-2" align="end">
              <DropdownMenuItem asChild>
                <button
                  onClick={() => setOpen(true)}
                  className="flex gap-2 items-center cursor-pointer text-foreground"
                >
                  <Eye width={22} height={22} /> Ouvrir
                </button>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <a
                  href={srcUrl}
                  download
                  className="flex gap-2 items-center cursor-pointer text-foreground"
                >
                  <Download width={22} height={22} /> Télécharger
                </a>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <div className="relative h-[17rem] overflow-hidden rounded-md bg-white flex items-center justify-center">
            {isThumbLoading && (
              <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/90">
                <LoadingSpinner className="text-primary" size={18} />
              </div>
            )}
            <div className="">
              <div className="cursor-pointer">
                <iframe
                  title="Office Embedded View"
                  src={iframeSrc}
                  width={width}
                  height={height}
                  frameBorder="0"
                  style={{ border: "none", width: width, height: height }}
                  className="pointer-events-none"
                  onLoad={() => setIsThumbLoading(false)}
                />
              </div>
            </div>
          </div>
        </DialogTrigger>

        <DialogContent className="sm:max-w-4xl sm:w-full h-[90vh] max-w-full flex flex-col">
          <DialogHeader className="max-h-32">
            <DialogTitle>Aperçu complet</DialogTitle>
            <DialogDescription>
              Visualisation via Office Online
            </DialogDescription>
          </DialogHeader>

          <div className="flex-1">
            <iframe
              title="Office Embedded View"
              src={iframeSrc}
              width="100%"
              height="100%"
              style={{ border: "none", flex: 1 }}
            />
          </div>

          <DialogClose asChild>
            <Button variant="outline" className="mt-4 w-max m-auto">
              Fermer
            </Button>
          </DialogClose>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default OfficeThumbnail;
